export const getPaymentError = (orderCode) => {
  return (dispatch, getState, { api }) => {
    return api.getPaymentError(orderCode).then(
      (data) => {
        return { wasSuccessful: true, error: data.errorMessage };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
